import { useContext } from 'react';
import {
  Box,
  Typography,
} from '@mui/material';

import AdminSidebar from 'src/Components/Admin/Sidebar/AdminSidebar';
import InstructorSidebar from 'src/Components/Admin/Sidebar/InstructorSidebar';

import { LoggedInUserContext } from '../../Components/Admin/AdminPageContainer'; // Import context

type Props = {};

const AdminAppSidebar = (props: Props) => {
  const selectedPage = useContext(LoggedInUserContext)?.selectedPage;   // Selected page)

  let titleText;
  if (selectedPage === "admin") {
    titleText = "Admin";
  } else if (selectedPage === "instructor") {
    titleText = "Instructor";
  }

  return (
    <Box className='admin-sidebar'>
      {/* Title Section - TODO - Remove after app bar has tabs since that will tell the user what they are looking at*/}
      <Box sx={{ paddingLeft: '16px', paddingTop: '16px' }}>
        <Typography variant="h6">{titleText}</Typography>
      </Box>
      {/* Display Sidebar based on which page is selected */}
      {selectedPage === 'admin' ?
        <AdminSidebar /> :
        <InstructorSidebar />}
    </Box>
  );
};

export default AdminAppSidebar;